export default __webpack_public_path__ + "static/media/dahyun3.433cc8e6.jpg";